import { Signal } from "./types";

export class SignalCollector {
  private buffer: Signal[] = [];

  add(type: Signal["type"], target: string, value: number): void {
    this.buffer.push({ type, target, value, ts: new Date().toISOString() });
    if (this.buffer.length > 100) this.buffer.shift();
  }

  drain(): Signal[] {
    const copy = [...this.buffer];
    this.buffer = [];
    return copy;
  }
}
